const acceptableIds = [
  "Driver's license",
  "Passport",
  "Health card",
  "Permanent resident card",
  "Citizenship card",
  "Secure Certificate of Indian Status (SCIS)",
  "Nexus card",
  "Global entry card",
  "Provincial services card",
  "Provincial identity card",
];

const businessStructureOptions = [
  {
    item: 'Sole Proprietorship',
    id: 1,
  },
  {
    item: 'Corporation',
    id: 2,
  },
  {
    item: 'Partnership',
    id: 3,
  },
  {
    item: 'Individual',
    id: 4,
  },
];

const addressToolTip = [
  "If your address has a unit number enter it at the start followed by a dash. Do not add any spaces around the dash.",
  "The address below has a unit number of 10A",
  "10A-1000 Main St. Toronto ON",
];

const companyNameToolTip = [
  "Please ensure you enter the operating name for your business and not the legal business name in this field",
];

const projectGalleryToolTip = [
  "Upload photos of previous work you've completed.",
  "Supported file types include: jpg, png, tiff, gif, webp",
];

export {
  acceptableIds,
  businessStructureOptions,
  addressToolTip,
  companyNameToolTip,
  projectGalleryToolTip,
}